<script setup lang="ts"></script>

<template>
  <q-toolbar-title><PageTitle /></q-toolbar-title>
</template>
